import { z } from "zod";
import { createSelectValidator } from "../Inputs/Utils/createSelectValidator";
import { BID_CATEGORY, BID_STATUS } from "@/interfaces/bid_types";

// Bid name schema
export const BidNameSchema = z.object({
    bid_name: z.string().min(1, "Bid name is required")
        .max(150, "Bid name must be less than 150 characters")
})

export const BidStatusSchema = z.object({
    status: createSelectValidator(
        z.enum(BID_STATUS),
        "Status is required"
    )
})

export const BidCategorySchema = z.object({
    category: createSelectValidator(
        z.enum(BID_CATEGORY),
        "Category is required"
    )
})